import { setInfo, initSet, updateWxShareData } from '@/configs/common'

let BaseSetting = {}

BaseSetting.install = function(Vue) {
    Vue.prototype.$baseSetting = function(pageInfo) {
        if (pageInfo) {
            setInfo(pageInfo)
        }
    }
    Vue.prototype.$initSet = function(pageInfo) {
        initSet(pageInfo)
    }
    Vue.prototype.$updateWxShareData = shareInfo => {
        updateWxShareData(shareInfo)
    }
}

export default BaseSetting
